import config from '@app/config'
import { setCookie } from '@app/services'

import { DEFAULT_CULTURE, DEFAULT_LANGUAGE } from './constants'
import { getB2CUserCulture } from './getB2CUserCulture'
import { getCultureByDomain } from './getCultureByDomain'
import { isB2BView } from '../url'

export const getUserLanguage = () => {
  if (!isB2BView()) {
    const userLanguage = getB2CUserCulture()?.split('-')[0]
    if (userLanguage) {
      return userLanguage
    }

    const culture =
      getCultureByDomain() ||
      config.regionalSettings?.culture ||
      config.regionalSettings?.language ||
      navigator.language ||
      (navigator.languages && navigator.languages[0]) ||
      DEFAULT_CULTURE

    setCookie(config.variables.b2c_language, culture, 8760) // 1 year

    return culture.split('-')[0]
  }

  return config.regionalSettings?.language || DEFAULT_LANGUAGE
}
